import { render, staticRenderFns } from "./vgpQuillEditor.vue?vue&type=template&id=3800753e&"
import script from "./vgpQuillEditor.vue?vue&type=script&lang=js&"
export * from "./vgpQuillEditor.vue?vue&type=script&lang=js&"
import style0 from "./vgpQuillEditor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3800753e')) {
      api.createRecord('3800753e', component.options)
    } else {
      api.reload('3800753e', component.options)
    }
    module.hot.accept("./vgpQuillEditor.vue?vue&type=template&id=3800753e&", function () {
      api.rerender('3800753e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/taskSettings/vgpQuillEditor.vue"
export default component.exports